export const StrategiesPage = import('./StrategiesPage');
export const StrategyDetailsPage = import('./StrategyDetailsPage');
